import { render, staticRenderFns } from "./cardBox.vue?vue&type=template&id=150f4168&scoped=true&"
import script from "./cardBox.vue?vue&type=script&lang=js&"
export * from "./cardBox.vue?vue&type=script&lang=js&"
import style0 from "./cardBox.vue?vue&type=style&index=0&id=150f4168&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "150f4168",
  null
  
)

export default component.exports